import { ReactNode } from "react";
import { Box, Heading, Image, VStack } from "@chakra-ui/react";
import Logo from "components/elements/Logo";
import {
  AuthenticationProvider,
  useAuth,
} from "modules/authentication/providers/authentication-provider";

/*
const AuthLogo = () => {
  const { company } = useAuth();

  return (
    <Box w="180px" mx="auto" mb="18px">
      {company && company.logo ? (
        company.loginpage_logo ? (
          <Image mb="0px" src={company.loginpage_logo} />
        ) : (
          <Image mb="0px" src={company.logo} />
        )
      ) : (
        <Logo width="100%" mb="0px" />
      )}
    </Box>
  );
};
*/

export const AuthHeading = ({ title }: { title: string }) => (
  <Heading as="h2" fontWeight="600" fontSize="26px" lineHeight="150%" mt="0px" textAlign="center">
    {title}
  </Heading>
);

export function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <AuthenticationProvider>
      <VStack id="onboarding" bg="rgb(249, 248, 248)" minH="100vh" justifyContent="center">
        <Box
          mt="34px"
          w={{
            base: "auto",
            sm: "100%",
          }}
          px={{
            base: "none",
            sm: "24px",
          }}
        >
          {/* <AuthLogo /> */}
          {children}
        </Box>
      </VStack>
    </AuthenticationProvider>
  );
}
